export default __webpack_public_path__ + "22ecd30273fce147e6fe60afd54d56d5.png";